import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5.23 5.233c-.15 .245 -.23 .502 -.23 .767c0 1.131 1.461 2.117 3.62 2.628m4.357 .343c3.404 -.204 6.023 -1.456 6.023 -2.971c0 -1.657 -3.134 -3 -7 -3c-1.645 0 -3.158 .243 -4.353 .65","key":"svg-0"}],["path",{"d":"M5 6v12c0 1.657 3.134 3 7 3c3.245 0 5.974 -.946 6.767 -2.23m.233 -3.77v-9","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconCylinderOff = createReactComponent('outline', 'cylinder-off', 'CylinderOff', __iconNode);

export default IconCylinderOff;